import moment from 'moment';
import calculateAvailabilityTime from './calculateDaypartMenuAvailabilityTime';

export const checkCategoryAvailability = ({
  category,
  dayInFull,
  dateTimeSelected,
}: {
  category: Partial<Category | CategoryInfo> | undefined;
  dayInFull?: boolean;
  dateTimeSelected?: string;
}): [boolean, string] => {
  if (!category) return [true, ''];

  const { availability, days, start, end } = category;
  const timeString = calculateAvailabilityTime(
    !!availability,
    days,
    start,
    end,
    dayInFull,
  );

  const isAvailable = checkTimeAvailability({
    availability: Boolean(availability),
    days,
    start,
    end,
    dateTimeSelected,
  });

  return [isAvailable, timeString];
};

export const checkTimeAvailability = ({
  availability,
  days = [],
  start = '',
  end = '',
  timeBracket = 0,
  dateTimeSelected,
}: {
  availability: boolean;
  days?: Day[];
  start?: string | null;
  end?: string | null;
  timeBracket?: number;
  dateTimeSelected?: string;
}): boolean => {
  if (!availability) return true;
  if (!(days.length > 0) && !start && !end) return true;

  const selectedWeekDay = moment(dateTimeSelected).format('dddd').toUpperCase();
  const daysUppercased = days.map(day => day.toString().toUpperCase());

  const date = `${moment(dateTimeSelected).format('yyyy-MM-DD')}`;

  // Check if selected weekday
  if (daysUppercased.length > 0 && !daysUppercased.includes(selectedWeekDay)) {
    return false;
  }

  if (start && moment(`${date} ${start}`).diff(moment(dateTimeSelected)) > 0)
    return false;

  if (
    end &&
    moment(dateTimeSelected).diff(moment(`${date} ${end}`), 'minute') >
      timeBracket
  ) {
    return false;
  }

  return true;
};
